import { BookingServiceClient } from 'fitbeat.api-clients';
import { CardioOrResistance, WorkoutSettings } from 'fitbeat.gym-core';
import { BaseEquipment, EquipmentCombinations } from 'fitbeat.models';
import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import { getApiConfig } from '../../config';
import {
  changeWorkoutSettings,
  closeSetupScreen,
  ExpoFileSystem,
  IAppStore,
  saveWorkoutSettings,
  WorkoutAssetHelper,
} from '../../HomeWorkouts';
import { DeviceSetupSubScreenHeader } from '../../HomeWorkouts/components/DeviceSetup/DeviceSetupSubScreenHeader';
import {
  updatedWorkoutSettingsSelector,
  workoutSettingsIsUpdatingSelector,
} from '../../HomeWorkouts/selectors';
import theme from '../../theme';
import { UserDataConsumer } from '../../utils';
import { AuthTokenBuilder } from '../../utils/authTokenBuilder';
import TypeOfWorkoutWarning from './TypeOfWorkoutWarning';

interface IDispatchProps {
  saveMyWorkoutSettings(): void;
  updateWorkoutSettings(workoutSettings: WorkoutSettings);
  closeMySetupScreen();
}

interface IStateProps {
  updatedWorkoutSettings: WorkoutSettings;
  workoutSettingsIsUpdating: boolean;
  workoutToChangeTo: CardioOrResistance;
}

interface IOwnProps {
  user: any;
  t(str: string, args?: any): string;
}

type Props = IStateProps & IDispatchProps & IOwnProps;

class TypeOfWorkoutWarningPreWorkout extends Component<Props> {
  constructor(props) {
    super(props);
  }
  public render() {
    const { workoutSettingsIsUpdating, workoutToChangeTo } = this.props;
    return (
      <TypeOfWorkoutWarning
        isWorkoutTypeChangeLoading={workoutSettingsIsUpdating}
        workoutToChangeTo={workoutToChangeTo}
        saveAndClose={this.saveAndClose}
        onBackPress={this.onBackPress}
        Heading={this.renderWarningHeader}
        textColor={{color: theme.WHITE}}
      />
    );
  }
  private onBackPress = () => {
    const { closeMySetupScreen } = this.props;
    closeMySetupScreen();
  }

  private saveAndClose = () => {
    const {
      saveMyWorkoutSettings,
      workoutToChangeTo,
      updateWorkoutSettings,
      updatedWorkoutSettings,
    } = this.props;
    let newSettings = {};
    if (workoutToChangeTo === CardioOrResistance.Balance) {
      newSettings = {
        threeBodyGroups: WorkoutSettings.getFullBody(),
        allowBagContact: false,
      };
    }
    updateWorkoutSettings({
      ...updatedWorkoutSettings,
      ...newSettings,
      cardioOrResistance: workoutToChangeTo,
    });
    saveMyWorkoutSettings();
  }

  private renderWarningHeader = () => {
    const { t } =  this.props;
    return (
      <DeviceSetupSubScreenHeader
        title={t('typeOfWorkoutWarningScreenHeader')}
        onBackPress={this.onBackPress}
      />
    );
  }
}

const mapStateToProps = (state: IAppStore): IStateProps => {
  return {
    updatedWorkoutSettings: updatedWorkoutSettingsSelector(state),
    workoutToChangeTo: state.homeWorkouts.workoutTypeToShowWarningFor!,
    workoutSettingsIsUpdating: workoutSettingsIsUpdatingSelector(state),
  };
};

const mapDispatchToProps = (dispatch: any): IDispatchProps => {
  const bookingServiceClient = new BookingServiceClient(
    getApiConfig(),
    fetch,
    new AuthTokenBuilder(),
  );

  const workoutAssetHelper = new WorkoutAssetHelper(new ExpoFileSystem());

  return {
    saveMyWorkoutSettings: () =>
      dispatch(
        saveWorkoutSettings(bookingServiceClient, workoutAssetHelper, false),
      ),
    updateWorkoutSettings: (newWorkoutSettings: WorkoutSettings) =>
      dispatch(
        changeWorkoutSettings(JSON.parse(JSON.stringify(newWorkoutSettings))),
      ),
    closeMySetupScreen: () => dispatch(closeSetupScreen()),
  };
};

export default connect<IStateProps, IDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(
  translate(['bookings'], { wait: true })(
    UserDataConsumer(TypeOfWorkoutWarningPreWorkout),
  ),
);
